[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 5,
                "y": 8,
                "key": "xMSu7"
            },
            {
                "x": 4,
                "y": 8,
                "key": "4St2N"
            },
            {
                "x": 4,
                "y": 7,
                "key": "i1otH"
            },
            {
                "x": 5,
                "y": 7,
                "key": "RBCT-"
            },
            {
                "x": 5,
                "y": 4,
                "key": "6zmsi"
            },
            {
                "x": 6,
                "y": 4,
                "key": "UmGU9e9DGAW2cgtDM5LDE"
            },
            {
                "x": 6,
                "y": 3,
                "key": "Y_QtY"
            },
            {
                "x": 9,
                "y": 3,
                "key": "coDdJ"
            },
            {
                "x": 9,
                "y": 4,
                "key": "87Arv"
            },
            {
                "x": 10,
                "y": 4,
                "key": "m0tm9EaEvdCqJFffxHmqg"
            },
            {
                "x": 10,
                "y": 7,
                "key": "NjyBq"
            },
            {
                "x": 11,
                "y": 7,
                "key": "fSGPv"
            },
            {
                "x": 11,
                "y": 8,
                "key": "yISFx"
            },
            {
                "x": 9,
                "y": 8,
                "key": "VjHMM"
            },
            {
                "x": 9,
                "y": 9,
                "key": "U2EqybwO2xGhP4bxOgYGF"
            },
            {
                "x": 6,
                "y": 9,
                "key": "SNZ-8"
            },
            {
                "x": 6,
                "y": 8,
                "key": "tgAlOo15-hexJ72EDJs-g"
            }
        ]
    }
]